export interface IModalHeaderProps {
    title: string;
    subtitle?: string;
    onClick?: () => void;
    dataDismiss?: string;
    showDivider?: boolean;
}

export default function ModalHeader(props: IModalHeaderProps) {
    const {
        title,
        subtitle,
        onClick,
        dataDismiss = 'modal',
        showDivider = true,
    } = props;
    const borderClass = showDivider
        ? 'border border-solid border-t-0 border-r-0 border-l-0 border-[var(--nj-core-color-grey-300)]'
        : 'border-0';
    return (
        <div
            className={`nj-modal__header ${borderClass} py-[var(--nj-semantic-size-spacing-16)] px-[var(--nj-semantic-size-spacing-24)] gap-[var(--nj-semantic-size-spacing-48)] m-0`}
        >
            <div className="flex flex-col justify-center">
                <h1 className="nj-modal__title !text-[var(--nj-semantic-color-text-neutral-primary-default)] !text-[var(--nj-semantic-font-size-heading-xs)] !font-bold !leading-[var(--nj-semantic-line-height-heading-xs)] !tracking-[var(--nj-semantic-letter-spacing-none)]">
                    {title}
                </h1>
                {subtitle && (
                    <p className="!text-[var(--nj-semantic-color-text-neutral-tertiary-default)] text-[var(--nj-semantic-font-size-text-sm)] font-normal leading-[var(--nj-semantic-line-height-text-sm)] tracking-[var(--nj-semantic-letter-spacing-none)] m-0 mt-[var(--nj-semantic-size-spacing-4)]">
                        {subtitle}
                    </p>
                )}
            </div>
            <button
                type="button"
                className="nj-icon-btn nj-icon-btn--lg nj-icon-btn--secondary nj-modal__close"
                data-dismiss={dataDismiss}
                aria-label="Close"
                onClick={onClick}
            >
                <span className="nj-sr-only">Fermer la fenêtre</span>
                <span
                    aria-hidden="true"
                    className="nj-icon-btn__icon material-icons"
                >
                    close
                </span>
            </button>
        </div>
    );
}
